export default "__VITE_ASSET__L$bXuxrt__"